import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  font-size: ", ";\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { parseISO, format } from 'date-fns/fp';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Card } from './Card';
import { CardInfo } from '../cardInfo/CardInfo';
import { CARD_VARIANT } from './constants';
import { getHeaderVariant } from './utils/responsiveProps';
import { Tag } from '../tag/Tag';
import { Link } from '../link/Link';
var eventCardDateStyle = variant({
  key: 'card.event.date'
});
var Date = styled.span(_templateObject(), eventCardDateStyle, themeGet('card.event.date.fontSize'), themeGet('card.event.date.fontWeight'));
var Head = styled.div(_templateObject2());
export var EventCard = function EventCard(_ref) {
  var variant = _ref.variant,
      status = _ref.status,
      coverUrl = _ref.coverUrl,
      date = _ref.date,
      dateFormat = _ref.dateFormat,
      title = _ref.title,
      description = _ref.description,
      tags = _ref.tags,
      links = _ref.links,
      cardInfoData = _ref.cardInfoData,
      rest = _objectWithoutProperties(_ref, ["variant", "status", "coverUrl", "date", "dateFormat", "title", "description", "tags", "links", "cardInfoData"]);

  var headerVariant = getHeaderVariant(variant, coverUrl);
  var header = date &&
  /*#__PURE__*/
  React.createElement(Head, null,
  /*#__PURE__*/
  React.createElement(Date, {
    variant: headerVariant
  }, format(dateFormat, parseISO(date))), status);
  return (
    /*#__PURE__*/
    React.createElement(Card, _extends({
      variant: variant,
      coverUrl: coverUrl,
      header: header,
      footer: cardInfoData &&
      /*#__PURE__*/
      React.createElement(CardInfo, {
        data: cardInfoData
      })
    }, rest),
    /*#__PURE__*/
    React.createElement(Card.Meta, {
      title: title,
      description: description
    }, tags &&
    /*#__PURE__*/
    React.createElement(Tag.Group, {
      maxCounts: 2
    }, tags), links &&
    /*#__PURE__*/
    React.createElement(Link.Group, {
      maxCounts: 2
    }, links)))
  );
};
EventCard.defaultProps = {
  variant: CARD_VARIANT.VERTICAL,
  dateFormat: 'yyyy-MM-dd'
};